export default class CatNav {
  constructor(element, optionalContainer = document) {
    this.passedElement = element;
    this.optionalContainer = optionalContainer;
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElements();
      this.addEventListeners();
    }
  }


  openMenu = () => {
    // this.overlay.style.display = "block";
    setTimeout(() => {
      // this.overlay.classList.add('open');
    }, 50);
    document.body.classList.add('cat-nav-open');
  }

  closeMenu = () => {
    document.body.classList.remove('cat-nav-open');
    // this.overlay.classList.remove('open');
    setTimeout(() => {
      // this.overlay.style.display = "none";
    }, 50);
  }

  getElements = () => {
    this.toggles = this.optionalContainer.querySelectorAll(".js-cat-nav-toggle");
    // this.overlay = this.optionalContainer.querySelector(".rf-cat-overlay");
  }


  addEventListeners = () => {
    this.toggles.forEach((item, i) => {
      item.addEventListener('click', this.handleClick);
    });
  };

  checkIfOpen = () => {
    return document.body.classList.contains('cat-nav-open');
  }

  handleClick = () => {
    this.checkIfOpen() ? this.closeMenu() : this.openMenu();
  }

  removeEventListeners = () => {
    this.toggles.forEach((item, i) => {
      item.removeEventListener('click', this.handleClick);
    });
  }

  dismantle = () => {
    this.removeEventListeners();
    this.passedElement = null;
    this.initialised = false;
  }

}
